<template>
  <t-card>
    <t-form
      ref="formData"
      :model="formData"
      domain="roleManage"
      label-width="100px"
    >
      <t-row>
        <t-col :span="12">
          <t-form-item :label="$t('resource.roleManage.roleID')" prop="roleId">
            <t-input
              v-model="formData.roleId"
              :disabled="!isAdd"
              style="width: 98%"
            ></t-input>
          </t-form-item>
        </t-col>
        <t-col :span="12">
          <t-form-item
            :label="$t('resource.roleManage.roleName')"
            prop="roleName"
          >
            <t-input v-model="formData.roleName" style="width: 98%"></t-input>
          </t-form-item>
        </t-col>
      </t-row>
      <t-row>
        <t-col :span="24">
          <t-form-item
            :label="$t('resource.roleManage.roleAuths')"
            prop="roleAuths"
          >
            <t-select v-model="formData.roleAuths" multiple style="width: 99%">
              <t-option
                v-for="item in flrRoleAuths"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </t-option>
            </t-select>
          </t-form-item>
        </t-col>
      </t-row>
      <t-row>
        <t-col :span="22">
          <t-form-item
            :label="$t('resource.roleManage.enableFlg')"
            prop="enableFlg"
          >
            <t-radio-group v-model="formData.enableFlg">
              <t-radio
                v-for="item in flrEnableFlg"
                :key="item.value"
                :label="item.value"
                >{{ item.label }}</t-radio
              >
            </t-radio-group>
          </t-form-item>
        </t-col>
      </t-row>
      <t-row>
        <t-col :span="24">
          <t-form-item class="float-right" style="float: right">
            <t-button v-if="isAdd" @click="EntryOrChangeData">
              <t-svg-save style="vertical-align: -20%" />
              {{ $t("resource.sys.sure") }}
            </t-button>
            <t-button v-else @click="EntryOrChangeData">
              <t-svg-editor style="vertical-align: -20%" />
              {{ $t("resource.button.change") }}
            </t-button>
          </t-form-item>
        </t-col>
      </t-row>
    </t-form>
  </t-card>
</template>

<script>
import service from "@/services/roleManage";
export default {
  name: "RoleDialog",
  props: {
    roleId: {
      type: String,
      default: "",
    },
    isAdd: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      formData: {
        // ロールID
        roleId: "",
        // ロール名
        roleName: "",
        // ロール権限
        roleAuths: [],
        // 使用可能区分
        enableFlg: 1,
        version: 1,
      },
      // 権限List
      flrRoleAuths: [],
      flrEnableFlg: [],
    };
  },
  created() {
    service.Init({ roleId: this.roleId }, this.isAdd).then((res) => {
      this.flrRoleAuths = res.flrRoleAuths.optionArray;
      this.flrEnableFlg = res.flrEnableFlg.optionArray;
      this.formData.enableFlg = res.flrEnableFlg.defaultValue;
      if (!this.isAdd) {
        this.formData = res.roleInfo;
      }
    });
  },
  methods: {
    EntryOrChangeData() {
      this.$refs["formData"].validate((valid) => {
        if (valid) {
          const requestData = {
            ...this.formData,
            enableFlg: this.formData.enableFlg == 1 ? "1" : "0",
          };
          if (this.isAdd) {
            service.Entry(requestData, () => this.$emit("ok"));
          } else {
            service.Change(requestData, () => this.$emit("ok"));
          }
        }
      });
    },
  },
};
</script>
